import { create } from 'zustand';
import { ImoduleFilter } from '../types/global';
import { ISharedModules, ORDER_PROPERTIES_TO_SEARCH } from '../types/orders';

interface IfiltersState {
  catalogueSearchbarText: string;
  ordersSearchbarText: string;
  secondOrdersSearchbarText: string;
  logisticsServicesSearchbarText: string;
  catalogueFilters: ImoduleFilter[];
  logisticsServicesFilters: ImoduleFilter[];
  logisticsServicesListingFilters: ImoduleFilter[];
  ordersFilters: ImoduleFilter[];
  secondOrdersFilters: ImoduleFilter[];
  bussinesFilters: ImoduleFilter[];
  numberOfOrders?: number;
  sharedModule: ISharedModules;
  logisticServiceSharedModule: ISharedModules;
  propertyToFilterSearch: { name: string; propertyToFilter?: string };
  productsModuleListingFilters: ImoduleFilter[];
  configurationFilters: ImoduleFilter[];
  toolsModuleListingSharedModule: ISharedModules;
  billingModuleListingFilters: ImoduleFilter[];

  setPropertyToFilterSearch: (propertyToFilterSearch: { name: string; propertyToFilter?: string }) => void;
  setCatalogueFilters: (catalogueFilters: ImoduleFilter[]) => void;
  setLogisticsServicesFilters: (logisticsServicesFilters: ImoduleFilter[]) => void;
  setLogisticsServicesListingFilters: (logisticsServicesListingFilters: ImoduleFilter[]) => void;
  setOrdersFilters: (ordersFilters: ImoduleFilter[]) => void;
  setSecondOrdersFilters: (secondOrdersFilters: ImoduleFilter[]) => void;
  setBussinesFilters: (bussinesFilters: ImoduleFilter[]) => void;
  setNumberOfOrders: (numberOfOrders?: number) => void;
  setSharedModule: (sharedModule: ISharedModules) => void;
  setLogisticServiceSharedModule: (logisticServiceSharedModule: ISharedModules) => void;
  setCatalogueSearchbarText: (catalogueSearchbarText: string) => void;
  setOrdersSearchbarText: (ordersSearchbarText: string) => void;
  setSecondOrdersSearchbarText: (ordersSearchbarText: string) => void;
  setLogisticServicesSearchbarText: (logisticsServicesSearchbarText: string) => void;
  setProductsModuleListingFilters: (productsModuleListingFilters: ImoduleFilter[]) => void;
  setConfigurationFilters: (configurationFilters: ImoduleFilter[]) => void;
  setToolsModuleListingSharedModule: (toolsModuleListingSharedModule: ISharedModules) => void;
  setBillingModuleListingFilters: (billingModuleListingFilters: ImoduleFilter[]) => void;
}

const useFiltersState = create<IfiltersState>(set => ({
  catalogueSearchbarText: '',
  ordersSearchbarText: '',
  secondOrdersSearchbarText: '',
  logisticsServicesSearchbarText: '',
  catalogueFilters: [],
  logisticsServicesFilters: [],
  logisticsServicesListingFilters: [],
  ordersFilters: [],
  secondOrdersFilters: [],
  bussinesFilters: [],
  numberOfOrders: undefined,
  sharedModule: { title: 'Vista 1', key: 1, active: true },
  logisticServiceSharedModule: { title: 'Vista 1', key: 1, active: true },
  propertyToFilterSearch: { name: ORDER_PROPERTIES_TO_SEARCH.ORDER_NUMBER, propertyToFilter: 'ORDER_NUMBER' },
  productsModuleListingFilters: [],
  configurationFilters: [],
  toolsModuleListingSharedModule: { title: 'Clientes', key: 1, active: true },
  billingModuleListingFilters: [],

  setPropertyToFilterSearch: propertyToFilterSearch => set({ propertyToFilterSearch }),
  setCatalogueFilters: catalogueFilters => set({ catalogueFilters }),
  setLogisticsServicesFilters: logisticsServicesFilters => set({ logisticsServicesFilters }),
  setLogisticsServicesListingFilters: logisticsServicesListingFilters => set({ logisticsServicesListingFilters }),
  setOrdersFilters: ordersFilters => set({ ordersFilters }),
  setSecondOrdersFilters: secondOrdersFilters => set({ secondOrdersFilters }),
  setBussinesFilters: bussinesFilters => set({ bussinesFilters }),
  setNumberOfOrders: (numberOfOrders?: number) => set({ numberOfOrders }),
  setSharedModule: (sharedModule: ISharedModules) => set({ sharedModule }),
  setLogisticServiceSharedModule: (logisticServiceSharedModule: ISharedModules) => set({ logisticServiceSharedModule }),
  setCatalogueSearchbarText: (catalogueSearchbarText: string) => set({ catalogueSearchbarText }),
  setOrdersSearchbarText: (ordersSearchbarText: string) => set({ ordersSearchbarText }),
  setSecondOrdersSearchbarText: (secondOrdersSearchbarText: string) => set({ secondOrdersSearchbarText }),
  setLogisticServicesSearchbarText: (logisticsServicesSearchbarText: string) => set({ logisticsServicesSearchbarText }),
  setProductsModuleListingFilters: (productsModuleListingFilters: ImoduleFilter[]) =>
    set({ productsModuleListingFilters }),
  setConfigurationFilters: (configurationFilters: ImoduleFilter[]) => set({ configurationFilters }),
  setToolsModuleListingSharedModule: (toolsModuleListingSharedModule: ISharedModules) =>
    set({ toolsModuleListingSharedModule }),
  setBillingModuleListingFilters: (billingModuleListingFilters: ImoduleFilter[]) => set({ billingModuleListingFilters })
}));

export default useFiltersState;
